export const userTypes = {
    GET_ACCOUNT_LINKING_AUTH_TOKEN: "get_account_linking_auth_token",
    GET_ACCOUNT_LINKING_AUTH_CODE: "get_account_linking_auth_code"
}